import request from '@/util/request'

export function materialList(data) {
  return request({
    url: '/api/v1/delivery/material/count/list',
    method: 'get',
    params: data
  })
}

export function materialExport(data) {
  return request({
    url: '/api/v1/delivery/material/count/export',
    method: 'get',
    params: data
  })
}
